document.addEventListener('DOMContentLoaded', function() {
    // Create the overlay element and append it to the body
    const overlay = document.createElement('div');
    overlay.className = 'page-overlay';
    document.body.appendChild(overlay);

    // --- Filter Menu Logic ---
    const filterButton = document.querySelector('.tt-btn-col-open');
    const filterSidebar = document.querySelector('.aside.leftColumn');
    const filterCloseButton = document.querySelector('.tt-btn-col-close a');

    if (filterButton && filterSidebar) {
        const openFilterSidebar = () => {
            filterSidebar.classList.remove('desctop-no-sidebar');
            overlay.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
        };

        const closeFilterSidebar = () => {
            filterSidebar.classList.add('desctop-no-sidebar');
            overlay.classList.remove('is-visible');
            document.body.style.overflow = '';
        };

        filterButton.addEventListener('click', openFilterSidebar);
        if (filterCloseButton) {
            filterCloseButton.addEventListener('click', (e) => {
                e.preventDefault();
                closeFilterSidebar();
            });
        }
        // Close filter sidebar when overlay is clicked
        overlay.addEventListener('click', closeFilterSidebar);
    }

    // --- Main Menu Logic ---
    const menuButton = document.querySelector('.mainmenumob-js');
    const mainMenu = document.querySelector('.panel-menu');
    const menuCloseButton = document.querySelector('.mm-close'); // Assuming this is the close button for the main menu

    if (menuButton && mainMenu) {
        const openMainMenu = () => {
            // The theme likely adds an 'active' class to the menu
            // We will just manage the overlay here
            overlay.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
        };

        const closeMainMenu = () => {
            // The theme's own JS should handle closing the menu (removing the 'active' class)
            // We just need to hide the overlay
            overlay.classList.remove('is-visible');
            document.body.style.overflow = '';
        };

        menuButton.addEventListener('click', openMainMenu);
        if(menuCloseButton){
             menuCloseButton.addEventListener('click', closeMainMenu);
        }
       
        // If the main menu is closed by its own script, we need to know about it
        // to hide the overlay. We can use a MutationObserver for this.
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const isMenuOpen = mainMenu.classList.contains('active');
                    if (!isMenuOpen && overlay.classList.contains('is-visible')) {
                        closeMainMenu();
                    }
                }
            });
        });

        observer.observe(mainMenu, { attributes: true });
        
         // Also close the main menu when the overlay is clicked
        overlay.addEventListener('click', () => {
            if (mainMenu.classList.contains('active')) {
                // We need to trigger the theme's close mechanism. 
                // Often, this is done by clicking the close button programmatically.
                if (menuCloseButton) {
                    menuCloseButton.click();
                } else {
                    // Fallback if no close button is found
                    mainMenu.classList.remove('active');
                }
            }
        });
    }
});